import { render } from "./IconTrekMaterialCarbon.vue?vue&type=template&id=8174a468"
import script from "./IconTrekMaterialCarbon.vue?vue&type=script&lang=js"
export * from "./IconTrekMaterialCarbon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__